@for (field of normalizedFields(); track field) {
    @if (isFieldVisible(field)) {
        <div class="modal-panel" [class.disabled]="disabledField()">
            <div class="ft-label">{{ field.label }}</div>
            <ft-switch
                [state]="!!datasource()[field.name]"
                [disabledControl]="disabledField()"
                (stateChange)="datasource()[field.name] = $event"
            />
        </div>
    }
}
